import React, { useState, useEffect } from "react";

// Importing bootstrap components
import { Form, Button, Table } from "react-bootstrap";

// Importing common components
import WarningAlert from "common/Alert";
import HRPagination from "components/HRPagination";

import { batch, useDispatch, useSelector } from "react-redux";

// Importing designation slices
import {
  setDesignation,
  setIsDefaultSet,
} from "state/slices/designation/designationSlice";

import { useGetDesignationsQuery } from "state/slices/designation/designationApiSlice";

const DesignationViewManagement = React.memo(
  ({
    isAllowedToUpdate=false,
    isAllowedToDelete=false,
    handleCheckboxChange = () => {},
    handleEdit = () => {},
    deleteDesignationManage = () => {},
    selectedRow = null,
  }) => {
    const dispatch = useDispatch();

    const { data, refetch, isLoading } = useGetDesignationsQuery();

    const designations = useSelector((state) => state.designation.designations);
    const isDefaultSet = useSelector((state) => state.designation.isDefaultSet);

    useEffect(() => {
      if (data) {
        batch(() => {
          dispatch(setDesignation(data.designations));
          dispatch(setIsDefaultSet(data.isDefaultSet));
        });    
      }
    }, [data, dispatch]);

    useEffect(() => {
      refetch();
    }, [designations]);

    // Pagination states
    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(designations.length / ITEMS_PER_PAGE) || 0;
    const [currentPage, setCurrentPage] = useState(1);

    // Calculate the start and end index for the current page
    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

    return (
      <>
        {!isDefaultSet && designations.length > 0 && (
          <WarningAlert 
            icon={<i className="bi bi-exclamation-triangle-fill me-2"></i>}
            message="Warning: No default designation is set. Please set it to prevent rendering wrong data." 
          />
        )}
        <Table striped responsive bordered className="text-center">
          <thead>
            <tr>
              {(isAllowedToUpdate || isAllowedToDelete) && <th></th>}
              <th>S No.</th>
              <th>Designation</th>
              {(isAllowedToUpdate || isAllowedToDelete) && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {designations.length > 0 ? (
              designations
                .slice(indexOfFirstItem, indexOfLastItem)
                .map((row, index) => (
                  <tr key={row.id} id={row?.isDefault ? "default" : ""}>
                    {(isAllowedToUpdate || isAllowedToDelete) && (
                      <td>
                        <Form.Check
                          type="checkbox"
                          name="row"
                          value={row.id}
                          checked={selectedRow?.id === row.id}
                          onChange={(e) => handleCheckboxChange(e, row)}
                        />
                      </td>
                    )}
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{row.name}</td>
                    {(isAllowedToUpdate || isAllowedToDelete) && (
                      <td>
                        {isAllowedToUpdate && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="me-2"
                            disabled={
                              !selectedRow || selectedRow?.id !== row.id
                            }
                            onClick={() => handleEdit(row)}
                          >
                            <i className="bi bi-pencil-square"></i>
                          </Button>
                        )}

                        {isAllowedToDelete && (
                          <Button
                            size="sm"
                            variant="outline-danger"
                            disabled={
                              !selectedRow || selectedRow?.id !== row.id
                            }
                            onClick={deleteDesignationManage}
                          >
                            <i className="bi bi-trash3"></i>
                          </Button>
                        )}
                      </td>
                    )}
                  </tr>
                ))
            ) : (
              <tr className="bg-light border text-center">
                <td colSpan={6} className="text-muted">
                  {isLoading ? "Loading Data..." : "No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {/* Pagination */}
        <div className="d-flex justify-content-end">
          <HRPagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </>
    );
  }
);

export default DesignationViewManagement;
